// Build/deploy visibility for the web app.
// Populated at build time via env vars (set these in the CI/deploy step):
//   REACT_APP_GIT_SHA, REACT_APP_GIT_BRANCH, REACT_APP_BUILD_TIME
// Falls back to "dev" / "unknown" locally so it is always safe.
export const BUILD_INFO = {
  sha: process.env.REACT_APP_GIT_SHA || 'dev',
  branch: process.env.REACT_APP_GIT_BRANCH || 'unknown',
  builtAt: process.env.REACT_APP_BUILD_TIME || 'unknown',
};

// Expose non-invasively for runtime inspection (no UI impact).
if (typeof window !== 'undefined') {
  window.__APP_BUILD__ = BUILD_INFO;
  // eslint-disable-next-line no-console
  console.info('[build]', `${BUILD_INFO.branch}@${BUILD_INFO.sha}`, BUILD_INFO.builtAt);
}
